// @flow

import {HorizontalPositionElement, VerticalPositionElement, Types} from './constants';

export type HorizontalPositionElementType = $Keys<typeof HorizontalPositionElement>;
export type VerticalPositionElementType = $Keys<typeof VerticalPositionElement>;
export type PositionType = $Keys<typeof Types>;

export type Flipped = {|
    height: boolean,
    width: boolean,
|};
export type Style = {|
    top?: string,
    left?: string,
    transformOrigin?: string,
    width?: string,
    visibility?: string,
    '--auto-position-box-z-index'?: number,
|};
export type AnchorPosition = {|
    top: number,
    left: number,
|};
export type BoxPosition = {|
    vertical: number,
    horizontal: number,
|};
export type TransformOrigin = {|
    horizontal: HorizontalPositionElementType,
    vertical: VerticalPositionElementType,
|};

export type AnchorOrigin = {|
    horizontal: HorizontalPositionElementType,
    vertical: VerticalPositionElementType,
|};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./constants");
